import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';

class RegistryCollectionItemTileActions extends Component {
  constructor(props) {
    super(props);

    this.canQuickAdd = this.canQuickAdd.bind(this);
    this.buttonAction = this.buttonAction.bind(this);
    this.shortenText = this.shortenText.bind(this);
  }

  canQuickAdd() {
    const { isDefaultGiftCard, collectionItem } = this.props;

    return !isDefaultGiftCard && collectionItem.actions.add_to_cart && (
      (collectionItem.type === 'EXTERNAL' && collectionItem.cash_fund && !collectionItem.contributions.group_gift)
      || (collectionItem.type !== 'EXTERNAL' && !collectionItem.contributions.group_gift)
    );
  }

  buttonAction(e) {
    const { onAddToCart, onShowProduct } = this.props;

    e.stopPropagation();
    if (this.canQuickAdd()) {
      onAddToCart();
    } else {
      onShowProduct();
    }
  }

  shortenText(str) {
    const newString = str;
    return newString.length > 12 && str !== 'Temporarily Out of Stock' ?
      `${newString.slice(0, 13)}...` : 
      newString;
  }

  render() {
    const { collectionItem } = this.props;
    const buttonText = collectionItem.button_cta === 'Contribute'
      ? (<span>Contribute <span className="btn--long-text">To Gift</span></span>)
      : this.shortenText(collectionItem.button_cta);


    return (
      <span>
        <ButtonV2 name="buy-now" onClick={(e) => { this.buttonAction(e); }}>{buttonText}</ButtonV2>
      </span>
    );
  }
}

RegistryCollectionItemTileActions.propTypes = {
  collectionItem: PropTypes.shape({}).isRequired,
  onAddToCart: PropTypes.func.isRequired,
  onShowProduct: PropTypes.func.isRequired,
  isDefaultGiftCard: PropTypes.bool,
};

export default RegistryCollectionItemTileActions;



// WEBPACK FOOTER //
// ./src/components/registry/RegistryCollectionItemTileActions.jsx